import React, { useState, useEffect, useCallback } from 'react';
import { Slider } from './ui/slider';

interface ElementSizeSliderProps {
  value: number;
  onChange: (value: number) => void;
}

const ElementSizeSlider: React.FC<ElementSizeSliderProps> = ({ value, onChange }) => {
  // Use local state for immediate feedback
  const [localValue, setLocalValue] = useState(value);

  // Update local value when prop changes
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  // Debounced onChange handler
  const handleChange = useCallback(
    (newValue: number) => {
      setLocalValue(newValue);
      onChange(newValue);
    },
    [onChange]
  );

  return (
    <div className="flex items-center gap-2 mb-2">
      <span className="text-xs text-muted-foreground">Min</span>
      <Slider
        value={[localValue]}
        min={1}
        max={2}
        step={0.01}
        onValueChange={(values) => handleChange(values[0])}
        className="flex-1"
      />
      <span className="text-xs text-muted-foreground">Max</span>
    </div>
  );
};

export default ElementSizeSlider;
